const htmlEl = document.querySelector('html')

module.exports = {
  // PCかどうか
  isPC: htmlEl.classList.contains('-pc'),

  // SPかどうか
  isSP: htmlEl.classList.contains('-sp')
};



// WEBPACK FOOTER //
// ./src/script/libs/config.js